import { render, staticRenderFns } from "./SitesWaysTable.vue?vue&type=template&id=37c86e70"
import script from "./SitesWaysTable.vue?vue&type=script&lang=js"
export * from "./SitesWaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports